import { Component } from '@poa/core';
import { Link } from '@poa/router';
import { action, observable, Observer } from '@poa/state';
import React from 'react';
import { Tooltip } from 'react-tippy';
import { ACCESS_LEVEL, GRANTED_HOSTS, HOST_TO_URL } from '../store/auth/auth.constants';
import { ProfileModal } from './profile-modal/profile-modal';
import { ReactComponent as Hamburger } from '../img/svgo/hamburger.svg';
import { version } from '../index';

const image = require('../img/logo.png');


function displayHost(host) {
  switch (host) {
    case GRANTED_HOSTS.nc:
      return 'nc';
    case GRANTED_HOSTS.dm:
      return 'dm';
    case GRANTED_HOSTS.pd:
      return 'pd';
    case GRANTED_HOSTS.of:
      return 'of';
    default:
      return host;
  }
}


class Navbar extends React.Component {
  t; // injected by Poa
  router; // injected by Poa
  store; // injected by Poa
  actions; // injected by Poa

  localState = observable({
    isModalOpened: false,
    tooltipOpened: false,
    showNav: false
  });

  toggleTooltip = action(() => {
    if (!this.localState.tooltipOpened) {
      document.addEventListener('click', this.handleOutsideClick);
    } else {
      document.removeEventListener('click', this.handleOutsideClick);
    }

    this.localState.tooltipOpened = !this.localState.tooltipOpened;
  });

  toggleNavItems = action(() => {
    this.localState.showNav = !this.localState.showNav;
  });

  handleOutsideClick = e => {
    if (this.node && this.node.contains(e.target)) {
      return;
    }

    if (e.defaultPrevented) {
      return;
    }

    this.toggleTooltip();
  };

  onModalClose = action(() => {
    this.localState.isModalOpened = false;
  });

  onModalOpen = action(() => {
    this.toggleTooltip();
    this.localState.isModalOpened = true;
  });

  async onFetch() {
    const response = await this.env.http.get('agency');

    return response.data;
  }

  onClearCacheClick = async () => {
    try {
      await this.env.http.get('/cache/clear');
      this.env.alert('Успех', 'Кеш успешно почищен', 'success');
    } catch (e) {
      this.env.alert('Ошибка', `Ошибка при чистке кеша`, 'error');
    }
  };

  purgeKeys(model) {
    Object.keys(model).forEach(key => {
      if (key.includes('verbose')) {
        delete model[key];
        return;
      }

      const value = model[key];

      if (typeof value === 'string') {
        if (value.includes('.')) {
          model[key] = parseFloat(value);
        } else {
          model[key] = parseInt(value, 10);
        }
      }
    });
  }

  async onUpdate(model, selectedSite, isAdding) {
    if (isAdding) {
      this.purgeKeys(model);
      await this.env.http.post('agency/', { ...model, site: selectedSite });
    } else {
      const m = model[selectedSite];
      this.purgeKeys(m);
      await this.env.http.post('agency/', { ...m, site: selectedSite });
    }
  }

  render() {
    return (
      <header className='header'>
        <div className='inner'>
          <div className='left'>
            <div>
              <div>
                {this.store.auth.canShow.reports && (
                  <Link to='/reports' className='logo'>
                    <img src={image} alt='img' />
                  </Link>
                )}
              </div>
              <div className='host-picker'>
                <Tooltip
                  interactive={true}
                  arrow={true}
                  trigger='click focus'
                  theme='light'
                  key={2}
                  html={
                    <div className='nickid-tooltip profile-tooltip'>
                      {this.store.auth.accessHosts.map(host => (
                        <React.Fragment key={host}>
                          <div className='link'>
                            <a href={HOST_TO_URL[host]}>{displayHost(host)}</a>
                          </div>
                        </React.Fragment>
                      ))}
                    </div>
                  }
                  position='bottom'
                >
                  {displayHost(this.store.auth.currentHost)}
                </Tooltip>
              </div>
            </div>
          </div>
          <div className='menu-icon' onClick={this.toggleNavItems}>
            <Hamburger />
          </div>
          <div className={`right  ${this.localState.showNav && 'active'}`}>
            <div className='menu-wrapper'>
              <ul className='menu'>
                {this.store.auth.canShow.dashboard && (
                  <li>
                    <Link to='/dashboard' data-test-id='dashboard' activeClassName='active'>
                      {this.t('dashboard')}
                    </Link>
                  </li>
                )}
                {this.store.auth.canShow.accounts && (
                  <li>
                    <Link to='/accounts' data-test-id='accounts' activeClassName='active'>
                      {this.t('accounts')}
                    </Link>
                  </li>
                )}
                {this.store.auth.canShow.reports && (
                  <li>
                    <Link to='/reports' data-test-id='reports' activeClassName='active'>
                      {this.t('reports')}
                    </Link>
                  </li>
                )}
                {this.store.auth.canShow.statistics && (
                  <li>
                    <Link to='/finances' data-test-id='finances' activeClassName='active'>
                      {this.t('statistics')}
                    </Link>
                  </li>
                )}
                {this.store.auth.canShow.calendar2 && (
                  <li>
                    <Link to='/calendar2' data-test-id='calendar2' activeClassName='active'>
                      {this.t('calendar2')}
                    </Link>
                  </li>
                )}
                {this.store.auth.canShow.letters && (
                  <li>
                    <Link to='/letters' data-test-id='letters' activeClassName='active'>
                      {this.t('letters')}
                    </Link>
                  </li>
                )}
                {this.store.auth.canShow.clientsList && (
                  <li>
                    <Link to='/clients' data-test-id='clients' activeClassName='active'>
                      {this.t('clients')}
                    </Link>
                  </li>
                )}
                {this.store.auth.canShow.general && (
                  <li>
                    <Link to='/general' data-test-id='general' activeClassName='active'>
                      {this.t('general')}
                    </Link>
                  </li>
                )}
              </ul>
            </div>

            <Tooltip
              interactive={true}
              arrow={true}
              open={this.localState.tooltipOpened}
              key={1}
              theme='light'
              html={
                <div className='nickid-tooltip profile-tooltip'>
                  {this.store.auth.canShow.staff && (
                    <div className='link' onClick={() => this.router.push('/staff')}>
                      <a href='#/'>{this.t('staff')}</a>
                    </div>
                  )}
                  {this.store.auth.canShow.transfers &&
                    this.store.auth.accessLevel === ACCESS_LEVEL.agency && (
                      <div className='link' onClick={() => this.router.push('/transfers')}>
                        <a href='#/'>{this.t('transfers')}</a>
                      </div>
                    )}
                  {this.store.auth.canShow.wallet &&
                    this.store.auth.accessLevel === ACCESS_LEVEL.agency && (
                      <div className='link' onClick={() => window.open("http://pay.synctool.team", '_blank')}>
                        <a href='#/'>{this.t('wallet')}</a>
                      </div>
                    )}
                  {this.store.auth.canShow.daemons && (
                    <div className='link' onClick={() => this.router.push('/daemons')}>
                      <a href='#/'>{this.t('daemons')}</a>
                    </div>
                  )}
                  {this.store.auth.canShow.archives && (
                    <div className='link' onClick={() => this.router.push('/archives')}>
                      <a href='#/'>{this.t('archives')}</a>
                    </div>
                  )}
                  {this.store.auth.canShow.contactInfo && (
                    <div className='link' onClick={() => this.router.push('/contactInfo')}>
                      <a href='#/'>{this.t('contactInfo')}</a>
                    </div>
                  )}
                  {this.store.auth.canShow.gifts && (
                    <div className='link' onClick={() => this.router.push('/gifts')}>
                      <a href='#/'>{this.t('gifts')}</a>
                    </div>
                  )}
                  {this.store.auth.canShow.chats && (
                    <div className='link' onClick={() => this.router.push('/chats')}>
                      <a href='#/'>{this.t('chats')}</a>
                    </div>
                  )}
                  {this.store.auth.canShow.payers && (
                    <div className='link' onClick={() => this.router.push('/payers')}>
                      <a href='#/'>{this.t('payers')}</a>
                    </div>
                  )}
                  <div className='link' onClick={this.onClearCacheClick}>
                    <a href='#/'>{this.t('clearCache')}</a>
                  </div>
                  <div className='link' onClick={() => this.router.push('/menu')}>
                    <a href='#/'>{this.t('settings')}</a>
                  </div>
                  <div className='hr' />
                  <div
                    className='link'
                    onClick={() => this.actions.authActions.invalidateSession()}
                  >
                    <a href='#/'>{this.t('logout')}</a>
                  </div>
                  <div className='link small'>
                    <a href='#/'>{version}</a>
                  </div>
                </div>
              }
              position='bottom'
            >
              <div className='profile-link' onClick={this.toggleTooltip}>
                <i className='material-icons'>face</i>
              </div>
            </Tooltip>

          </div>
        </div>
        <Observer>
          {() => (
            <ProfileModal
              isOpened={this.localState.isModalOpened}
              requestClose={this.onModalClose}
              onFetch={() => this.onFetch()}
              profileId='agency'
              onUpdate={(id, model, selectedSite, isAdding) => {
                this.onUpdate(model, selectedSite, isAdding);
              }}
              variant='agency'
            />
          )}
        </Observer>
      </header>
    );
  }
}

export default Component({ namespaces: ['common'] })(Navbar);
